import React, { useState, useCallback, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { authAPI } from "../services/AuthAPI";
import { pdpaAPI } from "../services/PdpaAPI";
import { Paper, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Box, Button } from "@material-ui/core";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Download from "downloadjs";
import moment from "moment"
import './managetype.css'

const ManagePDPA = ({ isMobile, closeNav }) => {
    const dispatch = useDispatch()
    const { isLogin, isLoading, userData } = useSelector(state => state.user)
    const [data, setData] = useState([])
    const [prefix, setPrefix] = useState([])
    const [page, setPage] = useState(0)
    const [pdpa, setPdpa] = useState(2)
    const [username, setUsername] = useState("")
    const [max, setMax] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (isLogin) {
            dispatch({ type: "PREFIX_FETCH_START" })
            authAPI.getPrefixAdmin()
                .then((res) => {
                    if (res.status == 200) {
                        setPrefix(res.message)
                    }
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
                .catch((err) => {
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
        }
    }, [isLogin])

    useEffect(() => {
        setPage(0)
    }, [username, pdpa])

    const Export_Excel = useCallback(async () => {
        try {
            setLoading(true)
            let result = await pdpaAPI.DownloadFile({ pdpa })
            Download(
                result.data,
                `Report PDPA ${moment().format("YYYY-MM-DD")}.xlsx`,
                result.headers["content-type"]
            );
            setLoading(false)
        } catch (error) {
            alert(error.message)
            setLoading(false)
        }
    }, [pdpa])

    useEffect(() => {
        if (isLogin) {
            dispatch({ type: "PREFIX_FETCH_START" })
            pdpaAPI.CompanyAll({ page: page + 1, pdpa, username })
                .then((res) => {
                    if (res.status == 200) {
                        setData(res.message)
                        setMax(res.total_page)
                    }
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
                .catch((err) => {
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
        }

    }, [isLogin, page, pdpa, username])

    const clearText = useCallback((text) => {
        let newText = text.replace(/^(DB7|[\D]+)/g, "")
        return newText
    }, [data])

    const companyFind = useCallback((text) => {
        let newText = (text.match(/^(DB7|[\D]+)/g) || [""])?.[0]
        let find = prefix.find((res) => res.prefix == (newText == "" ? null : newText))
        return find ? find.name_th : "หาไม่เจอ"
    }, [prefix])

    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(4, 3)
        },
    }));

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const classes = useStyles();

    return (
        <>
            {!isLoading &&
                <div className='container h-100vh' style={{ display: closeNav ? 'block' : isMobile ? 'none' : 'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none' : '0' }}>
                    <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%' }}>
                        <Box display={'flex'}>
                            <h3 style={{ fontSize: '38px', marginRight: 15 }}>จัดการ PDPA</h3>
                            {!loading && <FileDownloadIcon onClick={() => Export_Excel()} style={{ margin: 'auto 0', cursor: 'pointer' }} />}
                        </Box>
                        <Box display={'flex'} justifyContent={"space-between"} padding={0.5}>
                            <Box display={'flex'} margin="auto 0">
                                <div onClick={() => setPdpa(2)} style={{ border: '1px solid lightgray', cursor: 'pointer', borderRadius: 5, padding: 5, backgroundColor: pdpa == 2 ? "#5BB846" : "transparent", color: pdpa == 2 ? "white" : "black" }}>ทั้งหมด</div>
                                <div onClick={() => setPdpa(1)} style={{ border: '1px solid lightgray', cursor: 'pointer', borderRadius: 5, marginLeft: 10, padding: 5, backgroundColor: pdpa == 1 ? "#5BB846" : "transparent", color: pdpa == 1 ? "white" : "black" }}>เฉพาะทำแล้ว</div>
                                <div onClick={() => setPdpa(0)} style={{ border: '1px solid lightgray', cursor: 'pointer', borderRadius: 5, marginLeft: 10, padding: 5, backgroundColor: pdpa == 0 ? "#5BB846" : "transparent", color: pdpa == 0 ? "white" : "black" }}>เฉพาะยังไม่ทำ</div>
                            </Box>
                            <div><TextField label="ค้นหาจากเลขพนักงาน" onBlur={(e) => setUsername(e.target.value)} /></div>
                        </Box>
                        <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '1%', boxShadow: 'none', maxHeight: '75vh' }}>
                            <Table >
                                <TableHead style={{ backgroundColor: '#464B4F' }}>
                                    <TableRow >
                                        <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>รหัสพนักงาน</TableCell>
                                        <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>ชื่อบริษัท</TableCell>
                                        <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>ชื่อ</TableCell>
                                        <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>สถานะ</TableCell>
                                        {userData?.permission?.edit_prefix && <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }}></TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody style={{ textAlign: 'center' }}>
                                    {data.map((res, i) => (
                                        <TableRow style={{ backgroundColor: 'transparent' }} key={i}>
                                            <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{clearText(res.username)}</TableCell>
                                            <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{companyFind(res.username) || "-"}</TableCell>
                                            <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.fullname || "-"}</TableCell>
                                            <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>{res.pdpa ? "ทำแล้ว" : "ยังไม่ได้ทำ"}</TableCell>
                                            <TableCell style={{ textAlign: 'center', color: 'black', fontSize: '16px', fontWeight: 300 }}>
                                                {res.pdpa && <Link style={{ textDecoration: 'none' }} to={`view-pdpa/${res._id}`} >
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        style={{
                                                            border: "2px solid transparent",
                                                            backgroundColor: 'transparent',
                                                            borderRadius: "10px",
                                                            color: "#6C757D",
                                                            fontSize: "14px",
                                                            textDecoration: "none",
                                                            textTransform: "none",
                                                            boxShadow: 'none'
                                                        }}
                                                    >
                                                        <span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>ดู</span>
                                                    </Button></Link>}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer >
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            rowsPerPage={10}
                            page={max == 0 ? 0 : page}
                            component="div"
                            count={max}
                            onPageChange={handleChangePage}
                        />
                    </Paper>
                </div>}
        </>
    )
}
export default ManagePDPA